import { createSlice } from '@reduxjs/toolkit'

const fontScaleSlice = createSlice({
  name: 'fontScale',
  initialState: { mode: 'medium' },
  reducers: {
    setFontScale: (state, action) => { state.mode = action.payload },
  },
})

export const { setFontScale } = fontScaleSlice.actions
export default fontScaleSlice.reducer
